import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"text-align":"right"} }
const _hoisted_3 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { class: "mx-0 mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_spacer),
        (!_ctx.newRowActive && _ctx.editIndex === null)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "mt-8 mt-md-0",
              onClick: _ctx.startNewRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Agregar " + _toDisplayString(_ctx.catalog.singular || 'registro'), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      headers: _ctx.headers,
      items: _ctx.catalog.items,
      "item-value": "name",
      class: "elevation-0",
      "hide-default-footer": ""
    }, {
      header: _withCtx(({ props }) => [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header) => {
            return (_openBlock(), _createElementBlock("th", {
              key: header.value
            }, _toDisplayString(header.text), 1))
          }), 128)),
          _cache[0] || (_cache[0] = _createElementVNode("th", { style: {"width":"60px"} }, null, -1))
        ])
      ]),
      [`body.prepend`]: _withCtx(() => [
        (_ctx.newRowActive)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.fields, (field) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: field.value,
                  style: {"vertical-align":"middle"}
                }, [
                  (field.type !== 'color_picker')
                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                        key: 0,
                        modelValue: _ctx.newRow[field.value],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.newRow[field.value]) = $event),
                        label: field.label,
                        density: "compact",
                        "hide-details": "",
                        variant: "solo"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                    : (_openBlock(), _createBlock(_component_v_color_picker, {
                        key: 1,
                        modelValue: _ctx.newRow[field.value],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.newRow[field.value]) = $event),
                        flat: "",
                        "hide-canvas": "",
                        "show-swatches": "",
                        "swatches-max-height": "100",
                        "swatches-per-row": "8",
                        swatches: _ctx.toSwatches(field.items),
                        "hide-inputs": "",
                        width: "220",
                        style: {"margin":"0 auto"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "swatches"]))
                ]))
              }), 128)),
              _createElementVNode("td", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  onClick: _ctx.cancelNewRow
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Cancelar ")
                  ])),
                  _: 1,
                  __: [1]
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  size: "small",
                  onClick: _ctx.saveNewRow
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Guardar ")
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      item: _withCtx(({ item, index }) => [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.fields, (field) => {
            return (_openBlock(), _createElementBlock("td", {
              key: field.value,
              style: {"vertical-align":"middle"}
            }, [
              (_ctx.editIndex === index && field.type !== 'color_picker')
                ? (_openBlock(), _createBlock(_component_v_text_field, {
                    key: 0,
                    modelValue: _ctx.editItem[field.value],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.editItem[field.value]) = $event),
                    density: "compact",
                    "hide-details": "",
                    variant: "solo"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : (_ctx.editIndex === index && field.type === 'color_picker')
                  ? (_openBlock(), _createBlock(_component_v_color_picker, {
                      key: 1,
                      modelValue: _ctx.editItem[field.value],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.editItem[field.value]) = $event),
                      flat: "",
                      "hide-canvas": "",
                      "show-swatches": "",
                      "swatches-max-height": "100",
                      "swatches-per-row": "8",
                      swatches: _ctx.toSwatches(field.items),
                      "hide-inputs": "",
                      width: "220",
                      style: {"margin":"0 auto"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "swatches"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (field.type === 'color_picker')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (item[field.value])
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: _normalizeStyle({ background: item[field.value], width: '22px', height: '22px', borderRadius: '5px', display: 'inline-block' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(item[field.value]), 1)
                          ], 64))
                    ], 64))
            ]))
          }), 128)),
          _createElementVNode("td", _hoisted_3, [
            (_ctx.editIndex !== index)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "text",
                  size: "x-small",
                  onClick: ($event: any) => (_ctx.startEditRow(index, item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-pencil")
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "small",
                    onClick: _ctx.cancelEdit
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Cancelar ")
                    ])),
                    _: 1,
                    __: [4]
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    size: "small",
                    class: "mr-2",
                    onClick: ($event: any) => (_ctx.saveEditRow(index))
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Guardar ")
                    ])),
                    _: 2,
                    __: [5]
                  }, 1032, ["onClick"])
                ], 64)),
            (_ctx.editIndex !== index)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  icon: "",
                  variant: "text",
                  size: "x-small",
                  onClick: ($event: any) => (_ctx.deleteRow(index)),
                  class: "ml-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("mdi-delete")
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 2
    }, 1032, ["headers", "items"])
  ]))
}